import { Person } from 'classes'

export const accountId = state => {
  try {
    return state.user.currentProfile.account.id
  } catch (error) {
    return null
  }
}

export const accountType = state => {
  try {
    return state.user.currentProfile.account.accountType
  } catch (error) {
    return null
  }
}

export const assessmentScores = state => state.user?.assessmentScores

export const currentProfile = state =>
  new Person({
    user: {
      assessmentScores: assessmentScores(state),
    },
    ...state.user?.currentProfile,
  })

export const isPersonal = state => {
  try {
    return state.user.currentProfile.account.isPersonal
  } catch (error) {
    return false
  }
}

export const modules = state => state.user.modules

export const profiles = state => state.user.profiles

export const overviewSummary = state => state.user?.overviewSummary

export const isAuthenticated = state => state.session.isAuthenticated

/**
 * True right after a full page reload of a logged-in user (SIM-388): a session token was
 * restored from localStorage but the profile data was not, because it is no longer persisted.
 * SessionRestore uses it to call GET /sessions/current before rendering the routes.
 */
export const needsSessionRestore = state => {
  const { token, ssoToken, impersonateToken, currentProfile: profileInMemory } = state.user || {}
  const hasToken = Boolean(token || ssoToken || impersonateToken)
  return Boolean(state.session?.isAuthenticated && hasToken && !profileInMemory?.account)
}

export const isAssessmentCompleted = state => state.assessment.isCompleted

export const userProfiles = state => state.user.profiles.map(profile => new Person(profile))

export const name = state => {
  const { firstName, lastName } = currentProfile(state)
  return `${firstName} ${lastName}`
}

export const user = state => state.user

export const isImpersonating = state => !!state.user.internalAdmin.id

export const expirationMessage = state => state.session.expirationMessage

export const defaultAccount = state => state.user.defaultAccount

export const workingCircleVersion = state => state.user.workingCircleVersion || 0

export const workingCircleLastAdded = state => state.user.workingCircleLastAdded || null

export const isSsoAccount = state => {
  try {
    return !!state.user.currentProfile.account.enableSso
  } catch (error) {
    return false
  }
}
